import React from "react";
import EyeOpen from "@svg/eye-open.svg";
import EyeSlash from "@svg/eye-slash.svg";
import * as s from "./ShowPasswordToggle.sss";
const ShowPasswordToggle = ({ showPassword, toggleShowPassword }) => {
    return (React.createElement("button", { type: "button", onClick: toggleShowPassword, className: s.passwordButton }, showPassword ? (React.createElement(EyeOpen, { className: s.showPasswordIcon })) : (React.createElement(EyeSlash, { className: s.showPasswordIcon }))));
};
export default ShowPasswordToggle;
